var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRadioErrori = function SvgRadioErrori(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12 24a12 12 0 1 0 0-24 12 12 0 1 0 0 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.78 15.602 13.18 12l3.6-3.6a.79.79 0 0 0-.064-1.114.793.793 0 0 0-1.114-.066l-3.6 3.602-3.602-3.6c-.156-.14-.36-.21-.57-.198s-.404.106-.542.262A.793.793 0 0 0 7.222 8.4l3.602 3.6-3.602 3.602a.793.793 0 0 0 .066 1.112c.138.156.334.25.542.264a.8.8 0 0 0 .57-.198l3.602-3.6 3.6 3.6a.8.8 0 0 0 .57.196.8.8 0 0 0 .544-.262.785.785 0 0 0 .064-1.112"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRadioErrori);
export default ForwardRef;